import { StatusBar } from "expo-status-bar";
import React from "react";
import PropTypes from "prop-types";
import ENV from "app/utils/ENV";
import {
  StyleSheet,
  View,
  ScrollView,
  ActivityIndicator,
  TouchableWithoutFeedback,
  Platform,
  Dimensions,
  Alert,
} from "react-native";
import FilterBar from "app/components/FilterBar";
import TouchableOpacity from "app/components/TouchableOpacity";
import Text from "app/components/Text";
import TextInput from "app/components/TextInput";
import Value from "app/components/Value";
import ValueBlur from "app/components/ValueBlur";
import ValueInput from "app/components/ValueInput";
import Generation from "app/components/Generation";
import Canvas from "app/components/Canvas";
import ColorWheel from "app/components/ColorWheel";
import apiActions from "app/utils/apiActions";
import valueActions from "app/utils/valueActions";
import prefActions from "app/utils/prefActions";
import storageActions from "app/utils/storageActions";
import * as RootNavigation from "app/utils/RootNavigation.js";
import textHelpers from "app/utils/textHelpers";
import valueHelpers from "app/utils/valueHelpers";
import ftueHelpers from "app/utils/ftueHelpers";
import filterHelpers from "app/utils/filterHelpers";
import {
  styleSheet,
  colors,
  sizes,
  screenRatio,
  WIDTH,
} from "app/utils/styleSheet";

import Draggable from "app/components/Draggable";
import ValueListItem from "app/components/ValueListItem";
import ButtonGroup from "app/components/ButtonGroup";

import MomentBullet from "app/components/chapter/MomentBullet";
import MomentList from "app/components/chapter/MomentList";

import store from "app/redux/store";

import Hoverable from "app/components/Hoverable";
const createLogger = (msg, value) => () => {
  // console.log(msg, value.name);
};

import {
  Ionicons,
  Octicons,
  FontAwesome,
  Feather,
  Entypo,
  MaterialCommunityIcons,
} from "@expo/vector-icons";

import { StyleContext } from "app/contexts/Style";

export default class TextView extends React.Component {
  static contextType = StyleContext;
  constructor(props, context) {
    super(props, context);

    let { values, app, filters } = store.getState();
    let { loading, datetime } = app;
    // let levelIds = valueHelpers.getLevelIds(values, false, filters.fromBottom)
    // values = valueHelpers.filterToCurrentRevisions(values)
    // values = valueHelpers.sortByProgress(values, levelIds)
    let rawValues = values;
    // values = filterHelpers.apply(values);
    // let topLevel = valueHelpers.getTopLevel(levelIds)

    let condensedValues = valueHelpers.condenseAllRevisions(values);

    this.state = {
      values: condensedValues,
      rawValues,
      // topLevel,
      loading: true,
      // fetching: false,
      // filters,
      expandedIds: [],
      hideCaret: false,
      itemOption: "moments",
      layoutOption: "horizontal",
      layoutOption: ENV.WEB ? "color_wheel" : "vertical",
      layoutOption: "vertical",
      badgeOption: "badge",
      fetchOption: "top",
      filters,
      topValues: [],
    };
  }

  async componentDidMount() {
    this.subscribe();
    this.fetch();
  }

  fetch = async () => {
    let data = {};
    if (this.state.fetchOption == "top") {
      data.top = true;
    }
    let topValues = await valueActions.index("root", data);

    let { preferences } = store.getState();
    topValues = topValues?.filter(
      (v) => !preferences?.hiddenIds?.includes(v?.id),
    );

    this.setState({ loading: false, topValues });
  };

  subscribe = async () => {
    this.unsubscribe = store.subscribe(() => {
      let { values, app, preferences, filters } = store.getState();
      let { loading, datetime } = app;
      if (
        JSON.stringify(values) != JSON.stringify(this.state.rawValues) ||
        JSON.stringify(filters) != JSON.stringify(this.state.filters)
      ) {
        let rawValues = values;
        values = values.filter((v) => !preferences?.hiddenIds?.includes(v?.id));
        console.error("update values", values.length);
        console.log(
          "expanded ids",
          this.state.expandedIds,
          values.filter(
            (v) =>
              !!v.parent_ids.filter((pid) =>
                this.state.expandedIds.includes(pid),
              ).length,
          ),
        );
        // values = filterHelpers.apply(values);
        // let condensedValues = valueHelpers.condenseAllRevisions(values);
        this.setState({
          // values: condensedValues,
          values,
          rawValues,
          loading,
          filters,
        });
      }
    });

    // focus
    this.unsubscribeFocus = this.props.navigation.addListener(
      "focus",
      this.handleFocus,
    );
    if (ENV.WEB) window.addEventListener("focus", this.handleFocus);
    this.unsubscribeBlur = this.props.navigation.addListener(
      "blur",
      this.unsubscribe,
    );
    if (ENV.WEB) window.addEventListener("blur", this.unsubscribe);
  };

  componentWillUnmount() {
    // this.props.navigation.removeListener("focus");
    this.unsubscribeFocus();
    if (ENV.WEB) window.removeEventListener("focus", this.handleFocus);
    // this.props.navigation.removeListener("blur");
    this.unsubscribeBlur();
    if (ENV.WEB) window.removeEventListener("blur", this.handleFocus);
    this.unsubscribe();
  }

  handleFocus = () => {
    console.log("focus");
    this.subscribe();
    // this.updateView(false);
  };

  componentWillUnmount() {
    this.unsubscribe();
  }

  render() {
    let {
      values,
      loading,
      hideCaret,
      itemOption,
      layoutOption,
      badgeOption,
      fetchOption,
      expandAll,
      topValues,
    } = this.state;
    // let topValues = values.filter((v) => !v.parent_ids?.length);

    return (
      <View style={[this.styles().container]}>
        <StatusBar style="auto" />
        {/*<FilterBar
          noAutoFocus
          // hideFilters
          // hideQuery
          // hideCreate
        />*/}

        <View style={{ height: this.context.sizes.base }} />

        <ScrollView style={this.styles().scroller}>
          <ScrollView
            horizontal
            contentContainerStyle={this.styles().sliderRow}
          >
            {/*<View style={this.styles().buttonGroup}>
              <Text
                style={[
                  this.styles().button,
                  this.styles().groupedButton,
                  itemOption == "moments" && this.styles().selectedButton,
                ]}
                onPress={() => this.setState({ itemOption: "moments" })}
              >
                Moments
              </Text>
              <Text
                style={[
                  this.styles().button,
                  this.styles().groupedButton,
                  itemOption == "values" && this.styles().selectedButton,
                ]}
                onPress={() => this.setState({ itemOption: "values" })}
              >
                Values
              </Text>
              <Text
                style={[
                  this.styles().button,
                  this.styles().groupedButton,
                  itemOption == "text" && this.styles().selectedButton,
                ]}
                onPress={() => this.setState({ itemOption: "text" })}
              >
                Plaintext
              </Text>
            </View>*/}

            <ButtonGroup
              options={[
                { text: "Horizontal", value: "horizontal" },
                { text: "Vertical", value: "vertical" },
                { text: "Wheel", value: "color_wheel" },
              ]}
              selected={layoutOption}
              onSelect={(val) => this.setState({ layoutOption: val })}
            />

            <ButtonGroup
              options={[
                { text: "Badges", value: "badge" },
                { text: "Widgets", value: "values" },
              ]}
              selected={badgeOption}
              onSelect={(val) => this.setState({ badgeOption: val })}
            />

            <ButtonGroup
              options={[
                { text: "Smart", value: "smart" },
                { text: "Top", value: "top" },
                // { text: "Wheel", value: "color_wheel" },
              ]}
              selected={fetchOption}
              onSelect={async (val) => {
                await this.setState({ fetchOption: val });
                this.fetch();
              }}
            />

            <View
              style={{
                flex: 1,
                flexDirection: "row",
                justifyContent: "flex-end",
              }}
            >
              <Text
                style={[this.styles().button]}
                numberOfLines={1}
                onPress={() => {
                  !!this.momentListRef && this.momentListRef.expandAll();
                }}
              >
                Expand All
              </Text>
              {/*<Text
                style={this.styles().button}
                onPress={() => RootNavigation.navigate("Chapters")}
              >
                Chapters
              </Text>*/}
            </View>
          </ScrollView>

          <ScrollView horizontal>
            <View style={this.styles().contentWrapper}>
              <View style={this.styles().content}>
                {loading && !topValues?.length ? (
                  <ActivityIndicator />
                ) : (
                  this.renderList(topValues, 0)
                )}
              </View>
            </View>
          </ScrollView>
        </ScrollView>
      </View>
    );
  }

  renderList = (
    values,
    level,
    parent = null,
    uncles = [],
    parentIndex = null,
  ) => {
    let allValues = this.state.values;
    let { expandedIds, hideCaret, itemOption, layoutOption, badgeOption } =
      this.state;

    if (layoutOption == "color_wheel") {
      let rootValueIds = values.map((v) => v.id);
      return (
        <View>
          <ColorWheel
            values={textHelpers
              .uniq([...values, ...allValues], "root_id", "created_at")
              .filter(
                (value) =>
                  (!!value.color && rootValueIds.includes(value.id)) ||
                  expandedIds.includes(value.id) ||
                  !!value.parent_ids.filter((pid) => expandedIds.includes(pid))
                    .length,
              )}
            rootIds={values.map((v) => v.id)}
          />
          <MomentList
            moments={values
              .filter((value) => !!value.color)
              .map((value) => ({ value, id: value.id }))}
            ref={(ref) => (this.momentListRef = ref)}
            hideBadgeRow
            hideTags
            parentIsValue
            valueBadges={badgeOption == "values"}
            horizontal
            // preventAutoFocus={layoutOption == "horizontal"}
            valueBadges={badgeOption == "values"}
            onCollapseMoment={(value) => this.toggleExpanded(value.id)}
            onExpandMoment={(value) => this.toggleExpanded(value.id)}
          />
        </View>
      );
    }

    if (itemOption == "moments") {
      return (
        <MomentList
          moments={values.map((value) => ({ value, id: `value-${value.id}` }))}
          ref={(ref) => (this.momentListRef = ref)}
          hideBadgeRow
          hideTags
          parentIsValue
          valueBadges={badgeOption == "values"}
          horizontal={layoutOption == "horizontal"}
          // preventAutoFocus={layoutOption == "horizontal"}
          valueBadges={badgeOption == "values"}
        />
      );
    }

    return values.map((value, i) => {
      // let children = allValues.filter(v => v.parent_ids?.includes(value.id))
      // let children = allValues.filter(v => v.parent_ids?.some(pid => value.revision_ids.includes(pid)))
      let children = allValues.filter((v) =>
        value.revision_ids?.some((rid) => v.parent_ids?.includes(rid)),
      );
      if (!!value.revisions) {
        children.unshift({
          id: `${value.id}-revisions`,
          isRevision: true,
          text: "(revisions)",
          children: value.revisions.filter((r) => r.id != value.id),
        });
      }
      if (value.isRevision) {
        children = value.children;
      }
      // const found = arr1.some(r=> arr2.includes(r))

      let expanded = expandedIds.includes(value.id);

      if (itemOption == "moment") {
        return <MomentBullet key={`${i}-${value.id}`} moment={{ value }} />;
      } else if (itemOption == "values") {
        return <ValueListItem key={`${i}-${value.id}`} value={value} />;
      }

      return (
        <View key={`${i}-${value.id}`} style={this.styles().list}>
          <View key={`value-${value.id}`} style={[this.styles().row]}>
            {/*<TouchableWithoutFeedback >*/}
            <View style={[this.styles().valueWrapper]}>
              <Text
                style={this.styles().bullet}
                onPress={() => this.toggleExpanded(value.id)}
              >
                {!children?.length ? "•" : expanded ? "v" : ">"}
              </Text>
              <TextInput
                italic={value.isRevision}
                inputRef={(c) => (this[`ref-${value.id}`] = c)}
                autoFocus={level == 0 && i == 0}
                onExpand={() => this.toggleExpanded(value.id)}
                onCollapse={() => this.toggleExpanded(value.id)}
                focusPrevious={() =>
                  this.focusPrevious(value.id, values, i, parent)
                }
                focusNext={() =>
                  this.focusNext(
                    value.id,
                    expanded,
                    values,
                    i,
                    children,
                    uncles,
                    parentIndex,
                  )
                }
                focusPreviousJump={() =>
                  this.focusPreviousJump(value.id, values, i, parent)
                }
                focusNextJump={() =>
                  this.focusNextJump(value.id, expanded, values, i, children)
                }
                strike={value.completed}
                style={[
                  this.styles().textInput,
                  value.completed && { opacity: 0.5 },
                  hideCaret && { caretColor: "transparent" },
                ]}
              >
                {value.text}
              </TextInput>
            </View>
            {/*</TouchableWithoutFeedback>*/}
          </View>
          {expanded && this.renderList(children, level + 1, value, values, i)}
        </View>
      );
    });
  };

  toggleExpanded = (id) => {
    let { expandedIds } = this.state;
    if (expandedIds.includes(id)) {
      expandedIds.splice(expandedIds.indexOf(id), 1);
    } else {
      expandedIds.push(id);
    }
    console.log(
      "expanded ids",
      expandedIds,
      this.state.values.filter(
        (v) => !!v.parent_ids.filter((pid) => expandedIds.includes(pid)).length,
      ),
    );
    this.setState({ expandedIds });
  };

  focusNext = async (
    id,
    expanded,
    peers,
    index,
    children,
    uncles,
    parentIndex,
  ) => {
    console.log("focus next");
    let nextId;
    if (expanded && children.length) {
      // first child
      nextId = children[0].id;
    } else if (peers.length && peers.length - 1 > index) {
      // next peer
      nextId = peers[index + 1].id;
    } else {
      // next uncle
      nextId = uncles[parentIndex + 1]?.id;
    }
    if (nextId && this[`ref-${nextId}`]) {
      let ref = this[`ref-${nextId}`];
      if (!!ref?.focus) {
        // ref.addEventListener('focus', this.cursorToBeginning)
        await this.setState({ hideCaret: true });
        ref.focus();
        await new Promise((resolve) => setTimeout(resolve, 0));
        ref?.setSelectionRange && ref.setSelectionRange(0, 0);
        await this.setState({ hideCaret: false });
        // ref.removeEventListener('focus', this.cursorToBeginning)
      }
    } else {
      console.log("not found", nextId, this.refs);
    }
  };

  cursorToBeginning = (event) => {
    console.log(
      "listener",
      event?.target?.setSelectionRange,
      event?.srcElement?.setSelectionRange,
    );
    let ref = event?.target;
    ref?.setSelectionRange && ref.setSelectionRange(0, 0);
    ref?.setSelectionRange
      ? console.log("cursor to beginning")
      : console.log("no ref found");
  };

  focusPrevious = (id, peers, index, parent) => {
    console.log("focus previous");
    let prevId;
    if (peers.length && index > 0) {
      // prev peer
      prevId = peers[index - 1].id;
    } else {
      // parent
      prevId = parent.id;
    }
    if (prevId && this[`ref-${prevId}`]) {
      console.log(prevId, this[prevId]);
      this[`ref-${prevId}`].focus && this[`ref-${prevId}`].focus();
    } else {
      console.log("not found", prevId, this.refs);
    }
  };

  styles = () => ({
    container: {
      flex: 1,
      // alignItems: 'center',
      // alignItems: 'stretch',
    },
    contentWrapper: {
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "flex-start",
      flex: 1,
    },
    content: {
      // alignSelf: 'center',
      // alignItems: 'center',
      // flex: 1,
      // borderWidth: 1, borderColor: 'red',
      // maxWidth: WIDTH/2,
    },
    scroller: {
      padding: this.context.sizes.base,
    },
    list: {
      // alignSelf: 'center',
      // borderWidth: 1, borderColor: 'green',
      marginLeft: this.context.sizes.large,
      // alignSelf: 'flex-start',
    },
    row: {
      flexDirection: "row",
      // alignItems: 'center',
      // justifyContent: 'space-between',
      borderColor: this.context.colors.trim,
      // borderBottomWidth: 1,
      borderLeftWidth: 1,
      flex: 1,
    },
    valueWrapper: {
      flex: 1,
      flexDirection: "row",
      // alignSelf: 'stretch',
      // flexGrow: 0,
      // justifyContent: 'center',
      // alignItems: 'center',
      // borderColor: 'red', borderWidth: 2,
      padding: 5,
      paddingLeft: 0,
    },
    bullet: {
      width: this.context.sizes.large,
      height: this.context.sizes.large,
      textAlign: "center",
      fontSize: 12,
      borderWidth: 0.5,
      borderColor: this.context.colors.trim,
      borderRadius: this.context.sizes.large / 2,
      marginHorizontal: 3,
    },
    textInput: {
      flex: 1,
      // width: 399,
    },
    sliderRow: {
      flexDirection: "row",
      alignItems: "center",
      paddingLeft: this.context.sizes.base,
      marginBottom: this.context.sizes.base,
      height: 50,
    },
    button: {
      padding: this.context.sizes.base,
      borderRadius: this.context.sizes.smallBorderRadius,
      backgroundColor: this.context.colors.fill,
      marginRight: this.context.sizes.base,
    },
    selectedButton: {
      backgroundColor: this.context.colors.trim,
    },
    buttonGroup: {
      flexDirection: "row",
      borderRadius: this.context.sizes.smallBorderRadius,
      overflow: "hidden",
      marginRight: this.context.sizes.base,
    },
    groupedButton: {
      borderRadius: 0,
      marginRight: 0,
    },
  });
}
